import React, { useEffect, useState } from 'react';
import Banner from './Banner';
// import '../../../Assets/css/product_list.css';
import OfferListComp from './OfferListComp';
import FilterOffer from './filter-offers/FilterOffer';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';

const OfferList = () => {
  const [filtercall, setFiltercall] = useState(true);
  const [pageData, setpageData] = useState({});

  const pageInfo= useSelector((state)=>{
    return state?.persistedReducer?.product?.pageInfo
  })

  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
      setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
        window.removeEventListener("resize", resizeScreen);
    };
},[]);

  useEffect(()=>{
    setpageData(pageInfo);
  },[pageInfo])

// const pathname= window.location.pathname;
//   useEffect(()=>{
//     if(pathname.includes("gift-250") || pathname.includes("gift-500")){
//       setFiltercall(true);
//     }
//   },[pathname])
  return (
    <>
      <section className='mtMob50'>
      {
          pageData?.banner_image ?  <img src={screenWidth > 767 ? pageData?.banner_image : pageData?.banner_image_mobile} className='w-100' alt="banner" /> :  <Skeleton height={400} />
        }
      </section>
      <div className='container_productList'>
        <FilterOffer filtercall={() => setFiltercall(true)} />
        <OfferListComp filtercall={filtercall} />

      
      </div>
    </>
  )
}

export default OfferList;